<template>
  <section id="section__failure" class="view-container">
    <div class="width-100">
      <v-row no-gutters>
        <v-col cols="12" class="text-center">
          <v-card class="mt-5 mb-5 py-15" flat>
            <v-card-title class="font--m-2 justify-center">
              본인인증에 실패했습니다.
              <br />다시 시도하기 버튼을 눌러주세요
            </v-card-title>
          </v-card>
          <BasicButton :to="{ path: '/signup/step2' }"> 다시 시도하기 </BasicButton>
        </v-col>
      </v-row>
    </div>
  </section>
</template>
<script>
export default {
  created() {
    _meta({
      titles: ['본인인증실패'],
    })
  },
}
</script>
<style lang="scss" scoped>
#section__failure {
  .v-card {
    background-color: #fef0f0;
  }
}
</style>
